import React from 'react';
import { Wallet, Scissors, ChefHat, Shuffle } from 'lucide-react';
import { FadeIn } from './FadeIn';
const solutions = [{
  icon: Wallet,
  title: 'Expensive toy kits',
  description: "They only hold their attention for three minutes before they're back at your feet."
}, {
  icon: Scissors,
  title: 'Pinterest-style crafts',
  description: 'Require "instruction" time that you simply don\'t have while trying to cook dinner.'
}, {
  icon: ChefHat,
  title: '"Help me in the kitchen"',
  description: 'Often doubles your stress level instead of reducing their boredom.'
}, {
  icon: Shuffle,
  title: 'Random activities',
  description: 'Don\'t account for if your child is "bouncing off the walls" or "crashing and whining."'
}];
export function FailedSolutions() {
  return <section className="bg-cream py-24 sm:py-32" data-id="element-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-37">
        <div className="mx-auto max-w-2xl text-center mb-16" data-id="element-38">
          <FadeIn data-id="element-39">
            <h2 className="font-serif text-3xl font-bold tracking-tight text-navy sm:text-4xl" data-id="element-40">
              Why What You've Tried Hasn't Worked
            </h2>
          </FadeIn>
        </div>

        <div className="mx-auto max-w-5xl" data-id="element-41">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2" data-id="element-42">
            {solutions.map((solution, index) => <FadeIn key={solution.title} delay={index * 0.1} direction="up" data-id="element-43">
                <div className="relative flex flex-col gap-6 rounded-2xl bg-white p-8 shadow-soft transition-all hover:shadow-soft-lg h-full" data-id="element-44">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-cream-dark text-navy" data-id="element-45">
                    <solution.icon className="h-6 w-6" data-id="element-46" />
                  </div>
                  <div data-id="element-47">
                    <h3 className="text-xl font-semibold text-navy mb-3" data-id="element-48">
                      {solution.title}
                    </h3>
                    <p className="text-muted leading-relaxed" data-id="element-49">
                      {solution.description}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}